import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Select, message } from 'antd';
import request from '../../../../request';
import {
	API_VEHICLE_BRAND_LIST,
	API_VEHICLE_SREIES_LIST,
	API_VEHICLE_VEHICLE_LIST,
} from '../../../../hooks/carRental/_';
import emiter, {
  EVENT_VEHICLE_RESEARCH,
  EVENT_VEHICLE_SEARCH_SERIES, EVENT_VEHICLE_SEARCH_SERIES_LISTEN,
  EVENT_VEHICLE_SEARCH_VEHICLE, EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN,
} from '../../../../events';
import _ from 'lodash';

interface PropsType {
	mainFormFields?: any;
	form?: any;
	optionType?: string;
	isProduct?: any;
	detail?: any;
	enums?: any;
}

const MySelect: React.FC<PropsType> = props => {
	const { mainFormFields, form, optionType, isProduct, detail, enums } = props;
	const [brandList, setBrandList] = useState([]);
	const [seriesList, setSeriesList] = useState([]);
	const [vehicleList, setVehicleList] = useState([]);

	// 查询品牌列表
	const queryBrandList = () => {
		request({
			url: API_VEHICLE_BRAND_LIST,
			method: 'GET',
		})
			.then((res: any) => {
				setBrandList(res.data);
			})
			.catch(err => {
				message.error(err.message || '查询品牌列表失败');
			});
	};

	// 查询车系列表
	const querySeriesList = (id: string) => {
		request({
			url: API_VEHICLE_SREIES_LIST,
			method: 'GET',
			params: {
				brand_id: id,
			},
		})
			.then((res: any) => {
				setSeriesList(res.data);
			})
			.catch(err => {
				message.error(err.message || '查询品车系列表失败');
			});
	};

	// 查询车型年款列表
	const queryVehicleList = (id: string) => {
		request({
			url: API_VEHICLE_VEHICLE_LIST,
			method: 'GET',
			params: {
				series_id: id,
			},
		})
			.then((res: any) => {
				setVehicleList(res.data);
			})
			.catch(err => {
				message.error(err.message || '查询品车型年款列表失败');
			});
	};

	// 品牌选择完毕触发
	const changeBrand = (value: string) => {
		querySeriesList(value);
		form.setFieldsValue({
			series_id: undefined,
			vehicle_id: undefined,
		});
	};

	// 车系选择完毕触发
	const changeSeries = (value: string) => {
		queryVehicleList(value);
		form.setFieldsValue({
			vehicle_id: undefined,
		});
	};

	useEffect(() => {
		queryBrandList();
		emiter.on(EVENT_VEHICLE_SEARCH_SERIES, querySeriesList);
		emiter.on(EVENT_VEHICLE_SEARCH_VEHICLE, queryVehicleList);
    emiter.on(EVENT_VEHICLE_SEARCH_SERIES_LISTEN, querySeriesList);
		emiter.on(EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN, queryVehicleList);
		return () => {
			emiter.removeAllListeners(EVENT_VEHICLE_SEARCH_SERIES);
			emiter.removeAllListeners(EVENT_VEHICLE_SEARCH_VEHICLE);
			emiter.removeAllListeners(EVENT_VEHICLE_SEARCH_SERIES_LISTEN);
			emiter.removeAllListeners(EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN);
		};
	}, []);

	return (
		<>
			<Row gutter={24}>
				<Col span={6}>
					<Form.Item
						name={mainFormFields.pinpai.name}
						label={mainFormFields.pinpai.label}
						rules={[
							{
								required: mainFormFields.pinpai.required,
								message: mainFormFields.pinpai.message,
							},
						]}
					>
						<Select
							disabled={optionType === 'view' || isProduct}
							placeholder={mainFormFields.pinpai.placeholder}
							onChange={changeBrand}
							showSearch
							optionFilterProp="children"
							getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
						>
							{brandList &&
								brandList.map((item: any) => (
									<Select.Option key={item.brand_id} value={item.brand_id}>
										{item.brand_name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item noStyle shouldUpdate={(pre: any, cur: any) => pre.brand_id !== cur.brand_id}>
						{({ getFieldValue }) => {
							return (
								<Form.Item
									name={mainFormFields.chexi.name}
									label={mainFormFields.chexi.label}
									rules={[
										{
											required: mainFormFields.chexi.required,
											message: mainFormFields.chexi.message,
										},
									]}
								>
									<Select
										disabled={optionType === 'view' || !getFieldValue('brand_id') || isProduct}
										placeholder={mainFormFields.chexi.placeholder}
										onChange={changeSeries}
										showSearch
										optionFilterProp="children"
										getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
									>
										{seriesList &&
											seriesList.map((item: any) => (
												<Select.Option key={item.series_id} value={item.series_id}>
													{item.series_name}
												</Select.Option>
											))}
									</Select>
								</Form.Item>
							);
						}}
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item noStyle shouldUpdate={(pre: any, cur: any) => pre.series_id !== cur.series_id}>
						{({ getFieldValue }) => {
							return (
								<Form.Item
									name={mainFormFields.chexingniankuan.name}
									label={mainFormFields.chexingniankuan.label}
									rules={[
										{
											required: mainFormFields.chexingniankuan.required,
											message: mainFormFields.chexingniankuan.message,
										},
									]}
									extra={
										detail && detail?.seat_num
											? `${detail?.group_code}｜${
													_.find(enums?.transmission_type, ['key', detail.transmission_type])
														?.value
											  }档｜${
													_.find(enums?.fule_type, ['key', detail.fule_type])?.value || ''
											  }｜${detail?.seat_num}座｜${detail?.door_num}门`
											: ''
									}
								>
									<Select
										disabled={optionType === 'view' || !getFieldValue('series_id') || isProduct}
										placeholder={mainFormFields.chexingniankuan.placeholder}
										showSearch
										optionFilterProp="children"
										getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
									>
										{vehicleList &&
											vehicleList.map((item: any) => (
												<Select.Option key={item.vehicle_id} value={item.vehicle_id}>
													{item.vehicle_name}
												</Select.Option>
											))}
									</Select>
								</Form.Item>
							);
						}}
					</Form.Item>
				</Col>
			</Row>
		</>
	);
};

export default MySelect;
